import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import store and provider
import { store } from "./store/store";
import { Provider } from "react-redux";
import { AuthContextProvider } from "./store/auth-context";
import LanguageContextProvider from "./store/LanguageContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthContextProvider>
      <Provider store={store}>
        <LanguageContextProvider>
          <App />
        </LanguageContextProvider>
      </Provider>
    </AuthContextProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
